'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'rotate';
var width = 512;
var height = 512;
var aliases = [128260,"sync-alt"];
var unicode = 'f2f1';
var svgPathData = 'M512-8L433 71C332.7-25 173.6-23.7 75 75 25 125 0 190.5 0 256l64 0c0-49.2 18.7-98.3 56.2-135.8 73.6-73.6 192.2-75 267.5-3.9L312 192 512 192 512-8zM124.3 395.7L200 320 0 320 0 520 79 441c100.3 96 259.4 94.7 358-4 50-50 75-115.6 75-181l-64 0c0 49.2-18.7 98.3-56.2 135.8-73.6 73.6-192.2 75-267.5 3.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRotate = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;